import {parse, isValid, format, differenceInCalendarDays} from 'date-fns';
import fetchWrapper from "@/api/fetch-wrapper";

export const getOrganizationInfo = (inn, type) => {
    const query = `ajax/companyIntegrationDadata.php?inn=${inn}&type=${type}`;
    return fetchWrapper.get(query)
}

const kuvCache = new Map();
const KUV_CACHE_TTL = 5 * 60 * 1000;

export const getPolicyDayCount = (startDate, endDate) => {
    if (typeof startDate !== 'string' || typeof endDate !== 'string') return null;
    const start = parse(startDate, 'dd.MM.yyyy', new Date());
    const end = parse(endDate, 'dd.MM.yyyy', new Date());
    if (!isValid(start) || !isValid(end)
        || format(start, 'dd.MM.yyyy') !== startDate || format(end, 'dd.MM.yyyy') !== endDate) return null;
    const days = differenceInCalendarDays(end, start) + 1;
    return days >= 1 && days <= 365 ? days : null;
};

export const getKuv = async (inn, {isShortTerm = false, startDate = '', endDate = ''} = {}) => {
    const days = isShortTerm ? getPolicyDayCount(startDate, endDate) : 0;
    if (days === null) throw new Error('Срок полиса должен быть от 1 до 365 дней включительно');
    const key = JSON.stringify([inn, isShortTerm, days]);
    const now = Date.now();
    for (const [cacheKey, entry] of kuvCache) {
        if (entry.expires <= now) kuvCache.delete(cacheKey);
    }
    if (kuvCache.has(key)) return kuvCache.get(key).promise;

    const params = new URLSearchParams({inn, isShortTerm: String(isShortTerm)});
    if (isShortTerm) {
        params.set('startDate', startDate);
        params.set('endDate', endDate);
    }
    const entry = {expires: now + KUV_CACHE_TTL};
    entry.promise = fetchWrapper.get(`ajax/kuv.php?${params}`).then(result => {
        if (!result?.result || !result.tariffList?.length) {
            throw new Error(result?.error || 'Не удалось получить тарифы');
        }
        entry.expires = Date.now() + KUV_CACHE_TTL;
        return result;
    }).catch(error => {
        if (kuvCache.get(key) === entry) kuvCache.delete(key);
        throw error;
    });
    if (kuvCache.size >= 100) kuvCache.delete(kuvCache.keys().next().value);
    kuvCache.set(key, entry);
    return entry.promise;
};

export const asyncGetKuv = (inn) => {
    const query = `ajax/kuv.php?action=asyncGetKuv&inn=${inn}`;
    return fetchWrapper.get(query)
}
